import { render } from "./GooglePageUpdate.vue?vue&type=template&id=3a289b3a&scoped=true"
import script from "./GooglePageUpdate.vue?vue&type=script&lang=js"
export * from "./GooglePageUpdate.vue?vue&type=script&lang=js"

import "./GooglePageUpdate.vue?vue&type=style&index=0&id=3a289b3a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a289b3a"]])

export default __exports__